const KEY = "lm_pending_claim";
const BEST = "lm_best_score";
const SEEN = "lm_rules_seen";

export const getClaim = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
};
export const setClaim = (c) => localStorage.setItem(KEY, JSON.stringify(c));
export const clearClaim = () => localStorage.removeItem(KEY);
export const getBest = () => Number(localStorage.getItem(BEST) || 0);
export const setBest = (s) => s > getBest() && localStorage.setItem(BEST, String(s));
export const rulesSeen = () => localStorage.getItem(SEEN) === "1";
export const markRulesSeen = () => localStorage.setItem(SEEN, "1");
